import { EditorPlatformBridgeProviderAPI } from '@wix/editor-platform-feature-store/internal';
import { getInitializedBridgeEntrypoints } from './editorPlatformPackagesBridgeEntrypoints';
import { Shell } from 'repluggable';

export const EditorPlatformBridgeInitializer = {
  name: 'EDITOR_PLATFORM_BRIDGE_INITIALIZER_ENTRYPOINT',
  layer: 'DATA_SERVICE',

  getDependencyAPIs() {
    return [EditorPlatformBridgeProviderAPI];
  },

  extend(shell: Shell) {
    const bridgeProvider = shell.getAPI(EditorPlatformBridgeProviderAPI);
    getInitializedBridgeEntrypoints(
      bridgeProvider.getInitializedAPIs,
      (entrypoints) => {
        shell.addShells(entrypoints);
      },
    );
  },
};
